/* =========================================================
   Heatronics - real product titles in the SHOP menu.

   THE PROBLEM
   The menu card label comes from a metafield sub-heading, not
   from the product. blocks/_header-menu.liquid resolves it as

     link_obj.metafields.custom.sub_heading_product.value
       | default: link_obj.title

   so the sub-heading wins and the product title is only ever
   the fallback. Two consequences, both visible in the menu:

   1. The labels are not the product names. "hCore Bed Warmer
      (Solo)" is the sub-heading; the product is "Electric Bed
      Warmer for Single Bed | hCore by Heatronics".
   2. Worse - the sub-heading is not unique. hCore X and
      hCore X-L BOTH carry "hCore X", so the Heating Pad tab
      showed two different products under one identical label,
      one of them simply wrong.

   THE PROPER FIX IS ONE LINE, and it is not this file. In
   blocks/_header-menu.liquid, drop the metafield from that
   chain so it reads:

     {{ link_obj.title | default: child_link.title }}

   That file is 43KB and the theme API can only replace a file
   whole, so a one-expression change through it means retyping
   all of it - a poor trade for one line. Do it in the Shopify
   code editor, where it is a 20-second edit, then DELETE THIS
   FILE and its tag in snippets/stylesheets.liquid.

   WHY THE TITLE IS READ FROM THE PRODUCT
   The obvious shortcut is the image alt text, and it does not
   work: the bed warmer's alt is the real product title, but
   hCore X's is "ChatGPT_Image_Jul_10_2026_04_32_40_PM". Only
   the product is a reliable source, so each handle is read
   once from /products/<handle>.js and then cached in
   sessionStorage - eight small requests, once per session.

   WHY IT DOES NOT RUN ONCE AND STOP
   Two earlier versions failed here, and the reason is worth
   keeping. The dropdown is not in the document when a
   deferred script runs, so the first version found nothing
   and returned. The second retried until it found the links,
   painted them - and the labels came back anyway, because the
   menu section RE-RENDERS its dropdown afterwards and
   replaces the nodes. So painting is now idempotent and
   repeatable, and it is re-run whenever the menu's markup
   changes. Never latch a DOM fix that the page can re-render
   over the top of.
   ========================================================= */
(function () {
  if (window.__hbMenuTitles) return;
  window.__hbMenuTitles = true;

  var LINK = '.shop-dropdown__product-link';
  var LABEL = '.shop-dropdown__segment-text';
  var CACHE = 'hbMenuTitles';
  var titles = {};
  var wanted = {};

  try {
    var saved = window.sessionStorage.getItem(CACHE);
    if (saved) titles = JSON.parse(saved) || {};
  } catch (e) { titles = {}; }

  function remember() {
    try { window.sessionStorage.setItem(CACHE, JSON.stringify(titles)); } catch (e) {}
  }

  function handleOf(href) {
    if (!href) return null;
    var i = href.indexOf('/products/');
    if (i === -1) return null;
    var rest = href.slice(i + 10);
    var cut = rest.length;
    var stops = ['?', '#', '/'];
    for (var s = 0; s < stops.length; s++) {
      var at = rest.indexOf(stops[s]);
      if (at > -1 && at < cut) cut = at;
    }
    return rest.slice(0, cut) || null;
  }

  /* cheap, idempotent, safe to call as often as we like */
  function paint() {
    var links = document.querySelectorAll(LINK);
    for (var i = 0; i < links.length; i++) {
      var h = handleOf(links[i].getAttribute('href'));
      if (!h) continue;
      if (titles[h]) {
        var el = links[i].querySelector(LABEL);
        if (el && el.textContent.trim() !== titles[h]) el.textContent = titles[h];
      } else if (!wanted[h]) {
        wanted[h] = true;
        fetchTitle(h);
      }
    }
    return links.length;
  }

  function fetchTitle(handle) {
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product || !product.title) return;
        titles[handle] = String(product.title).trim();
        remember();
        paint();
      })
      .catch(function () { /* a menu label is never worth an error */ });
  }

  /* watch the menu section, because it re-renders its own
     dropdown and puts the sub-headings back */
  var watching = false;
  function watch() {
    if (watching || !window.MutationObserver) return;
    var link = document.querySelector(LINK);
    var root = link && link.closest ? link.closest('[id^="shopify-section"]') : null;
    if (!root) return;
    watching = true;
    var pending = null;
    new window.MutationObserver(function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(paint, 60);
    }).observe(root, { childList: true, subtree: true });
  }

  var ticks = 0;
  function tick() {
    var found = paint();
    if (found) watch();
    if (++ticks < 30) window.setTimeout(tick, ticks < 8 ? 400 : 1200);
  }

  function poke(e) {
    var t = e && e.target;
    if (!t || !t.closest) return;
    if (t.closest('[id^="shop-dropdown-"]') || /^shop$/i.test((t.textContent || '').trim())) {
      window.setTimeout(paint, 120);
    }
  }
  document.addEventListener('click', poke, true);
  document.addEventListener('pointerover', poke, true);
  document.addEventListener('focusin', poke, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }

  document.addEventListener('shopify:section:load', function () {
    watching = false;
    window.setTimeout(function () { paint(); watch(); }, 300);
  });
})();